import React from 'react';
import './CarouselItem.css';

type CarouselItemProps = {
  img: string,
  title: string,
}
const CarouselItem: React.FC<CarouselItemProps> = ({img, title}) => {
  return (
    <div className='lg:flex justify-center'>
      <div className='flex' style={{flex:1}}>
        <p className='text-5xl lg:text-6xl font-bold mt-auto mb-auto mx-auto '>{title}</p>
      </div>
      <div className='' style={{height: 580, flex:1}}>
        <img src={img} alt={title} className='' style={{maxHeight: '90%', maxWidth:'90%', width:'auto', height: 'auto'}}/>
      </div>
    </div>
  )
}
export default CarouselItem